import { createApp, h } from "vue";
import Bugsnag from "@bugsnag/js";
import BugsnagVue from "@bugsnag/plugin-vue";
import ElementPlus from "element-plus";
import baseBugsnag from "@nextories/vue-core-components/src/utils/modules/bugsnag";
import "@nextories/vue-tasks/src/assets/scss/external/element-variables.scss";
import nxtVueTasks from "@nextories/vue-tasks/src/main";
import helpers from './utils/helpers';
import AppApi from "./utils/AppApi";
import CustomerApi from "./utils/CustomerApi";
import MoverApi from "@nextories/vue-tasks/src/utils/MoverApi";
import App from "./App.vue";
import router from "./router";
import components from "./components";
import axios from "@nextories/vue-tasks/src/utils/modules/axios";
import baseAxios from "@nextories/vue-core-components/src/utils/modules/axios";
import { i18nPlugin } from "./plugins/i18n";
import piniaPlugin from "./plugins/pinia";

const app = createApp({
  data() {
    return {
      prefixCSS: import.meta.env.nxt.prefixCSS ? `${import.meta.env.nxt.prefixCSS}-` : "",
      locks: [],
      calendars: [],
      isAuth: false,
    };
  },
  render() {
    return h(App);
  },
});
app.use(i18nPlugin);
app.use(piniaPlugin);
baseBugsnag.config(import.meta.env.nxt);

if (nxtVueTasks && nxtVueTasks.install) {
  app.use(nxtVueTasks.install);
}

Object.assign(app.config.globalProperties.$helpers, helpers);
Object.entries(components).forEach((entry) => {
  const name = `${entry[0]}`;
  entry[1].name = name;
  app.component(name, entry[1]);
});
app.use(router);

// Init nextories api
app.config.globalProperties.$API = axios(router, undefined, undefined, undefined, [{
  key: 'n1',
  options: {
    apiKey: import.meta.env.VITE_APP_PUSHER_N1_KEY,
  },
}]);
window.connector = new AppApi(app.config.globalProperties.$API);

// Init customer api
app.config.globalProperties.$CUSTOMER_API = baseAxios(import.meta.env.VITE_APP_CUSTOMER_URL);
window.customerAppConnector = new CustomerApi(app.config.globalProperties.$CUSTOMER_API);

// Init mover api
app.config.globalProperties.$MOVER_API = axios(
  router,
  undefined,
  import.meta.env.VITE_APP_MOVER_API,
  import.meta.env.VITE_APP_MOVER_API_SECURITY_KEY,
);
window.moverAppConnector = new MoverApi(app.config.globalProperties.$MOVER_API, true);

app.mount("#app");
